"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.workshopDateWithTimezone = exports.getTimezone = exports.getWorkshopDate = exports.getTimeFormat = undefined;
var _moment = require("moment");
var _moment2 = _interopRequireDefault(_moment);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var getTimeFormat = exports.getTimeFormat = function getTimeFormat(event) {
  return event.timeFormat == "am_pm" ? "hh:mm a" : "HH:mm";
};
var getWorkshopDate = exports.getWorkshopDate = function getWorkshopDate(workshop, event, t) {
  var timeFormat = getTimeFormat(event);
  var start = (0, _moment2.default)(workshop.startDate).format(timeFormat);
  var end = (0, _moment2.default)(workshop.endDate).format(timeFormat);
  return "" + t('date.from_optional') + start + " " + t('date.to') + " " + end;
};
var getTimezone = exports.getTimezone = function getTimezone(event, otherData) {
  var timezone = (0, _moment2.default)();
  if (otherData.useEventTimezone) timezone.tz(event.virtualTimezone);
  return timezone.format('[GMT]Z');
};
var workshopDateWithTimezone = exports.workshopDateWithTimezone = function workshopDateWithTimezone(workshop, event, otherData, t) {
  return getWorkshopDate(workshop, event, t) + " " + getTimezone(event, otherData);
};